export const environment = {
  name: 'production',
  production: true,
  apiUrl: 'https://dev-crmsolutionapi.pl/api',
};
